// ANGULAR
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// MODELS
import { PostChangePasswordRequest } from '@models/usuarios.model';
// STORE
import { Store } from '@ngrx/store';
import { MainState } from '@store/main.reducer';
import { selectReturnHome } from '@store/app/app.selectors';
import { changePassword, logout } from '@store/session/session.actions';
// RXJS
import { first, Subscription } from 'rxjs';
// OTHERS
import { Paths } from '@constants/paths.const';

@Component({
  selector: 'app-change-password-required',
  templateUrl: './change-password-required.component.html',
  styleUrls: ['./change-password-required.component.css'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
  ]
})
export class ChangePasswordRequiredComponent implements OnInit, OnDestroy {
  newPasswordForm = { oldPass: '', newPass: '', repeatNewPass: '' };
  inputType: string = 'password';
  errorMessage: string;
  showErrorMessage: boolean = false;
  //Toggle passwords 
  showPass: boolean[] = [false, false, false];

  constructor(
    private store: Store<MainState>,
    private router: Router,
  ) { }

  ngOnInit(): void { }

  changePassword(): void {
    if (this.newPasswordForm.oldPass === this.newPasswordForm.newPass || this.newPasswordForm.oldPass === this.newPasswordForm.repeatNewPass) {
      this.errorMessage = 'La nueva contraseña no puede ser igual a la antigua.';
      this.showErrorMessage = true;
    } else if (this.newPasswordForm.newPass !== this.newPasswordForm.repeatNewPass) {
      this.errorMessage = 'Las contraseñas no coinciden.';
      this.showErrorMessage = true;
    } else if (this.newPasswordForm.oldPass && this.newPasswordForm.newPass === this.newPasswordForm.repeatNewPass) {
      this.showErrorMessage = false;
      const postChangePasswordRequest: PostChangePasswordRequest = {
        oldPassword: this.newPasswordForm.oldPass,
        newPassword: this.newPasswordForm.newPass,
        newPasswordRepeat: this.newPasswordForm.repeatNewPass
      };
      this.store.dispatch(changePassword({ postChangePasswordRequest: postChangePasswordRequest }));
    }
  }

  showPasswords(): void {
    if (this.newPasswordForm.oldPass || this.newPasswordForm.newPass || this.newPasswordForm.repeatNewPass) {
      if (this.inputType === "password") {
        this.inputType = "text";
      } else {
        this.inputType = "password";
      }
    } else {
      this.inputType = "password";
    }
  }

  logout(): void {
    this.store.select(selectReturnHome).pipe(first()).subscribe(
      returnHome => {
        if (returnHome) {
          this.router.navigate([Paths.home]);
        } else {
          this.store.dispatch(logout());
        }
      }
    );
  }

  ngOnDestroy(): void { }
}